const LOGIN_HASH = '#/auth/login'

let reloading = false

/**
 * FF-4076: sends the user to the login page with a full page load. The routers use hash routing, so
 * setting `location.hash` alone keeps the tab on the build it first loaded; a tab opened before a
 * deploy would sign the user back in to the old code. Reloading fetches the current `index.html`.
 *
 * The URL is rewritten with `replaceState`, which the router does not see, so the old page stays on
 * screen until the reload replaces it. A 401 and the `SIGNED_OUT` event can both arrive for one
 * sign-out, so only the first call reloads.
 */
export function reloadToLogin(): void {
  if (reloading) return
  reloading = true
  window.history.replaceState(null, '', LOGIN_HASH)
  window.location.reload()
}

/** True once `reloadToLogin` has run in this page, until the reload replaces it. */
export function isReloadingToLogin(): boolean {
  return reloading
}
